export function ComingSoon({ title, subtitle }: { title: string; subtitle: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-paper)] px-6">
      <div className="text-center max-w-md">
        <div className="inline-block px-4 py-2 mb-6 bg-[var(--color-accent)] text-white text-sm tracking-wide uppercase">
          Гордость 94
        </div>
        <h1 className="text-5xl mb-4" style={{ fontFamily: "var(--font-serif)" }}>{title}</h1>
        <p className="text-lg text-[var(--color-muted)]">{subtitle}</p>
      </div>
    </div>
  );
}
